import { FC } from 'react';
import styles from './Reward.module.scss';
import { Reward as RewardProps } from '../../../../shared/api/contract';
import { emptyTokenLogo, mellIcon } from '../../../../assets';
import {FlipNumber} from "../../../../shared/ui/flip-value/flip-value.ui.tsx";

const Reward: FC<RewardProps & { disable?: boolean }> = ({ amount, imgUri, symbol, disable = false }) => {
    return (
        <div
            className={styles.reward}
            style={{ opacity: disable ? 0.5 : 1 }}>
            <img
                src={symbol === 'MOON' ? mellIcon : imgUri ? imgUri : emptyTokenLogo}
                alt=""
            />
            <div className={styles.info + ' start'}>
                {/*<p>{Math.ceil(symbol === 'MOON' ? Number(amount) : Number(amount) / 1000000000000000000).toLocaleString()}</p>*/}
                <FlipNumber value={Math.ceil(symbol === 'MOON' ? Number(amount) : Number(amount) / 1000000000000000000).toLocaleString()}/>
                <p>{symbol}</p>
            </div>
        </div>
    );
};

export default Reward;
